import { defineMessage } from 'services/localization';

export const messages = {
    contactSupport: defineMessage('contact_support_1'),
};
